import { jwtDecode } from 'jwt-decode';

const TOKEN_EXPIRY_BUFFER_SECONDS = 300; // 5 minutes

export const isTokenExpired = (token, bufferSeconds = TOKEN_EXPIRY_BUFFER_SECONDS) => {
    try {
        const decoded = jwtDecode(token);
        const currentTime = Math.floor(Date.now() / 1000);
        const expiryTime = decoded.exp;
        return (expiryTime - currentTime) < bufferSeconds;
    } catch (error) {
        console.error('Error decoding token for expiration check:', error);
        return true;
    }
};

export const getTokenExpiryTime = (token) => {
    try {
        const decoded = jwtDecode(token);
        return decoded.exp * 1000; // Convert to milliseconds
    } catch (error) {
        console.error('Error getting token expiry time:', error);
        return 0;
    }
};
